module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Impressions of Carly")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#part-one-carly-of-the-desert"
    }
  }, [_vm._v("Part One: Carly of the Desert")]), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-one-a-plan"
    }
  }, [_vm._v("Chapter One: A Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-two-a-priest"
    }
  }, [_vm._v("Chapter Two: A Priest")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#part-two-impressions"
    }
  }, [_vm._v("Part Two: Impressions")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-one-a-confidant"
    }
  }, [_vm._v("Chapter One: A Confidant")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-two-a-believer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two: A Believer")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-three-a-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: A Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-four-a-poet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: A Poet")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-five-a-mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: A Mother")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-six-a-companion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: A Companion")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-seven-a-moment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: A Moment")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-eight-a-counsellor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: A Counsellor")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-nine-a-bedroom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: A Bedroom")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-ten-a-colleague",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: A Colleague")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-eleven-an-illness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: An illness")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-twelve-a-neighbour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: A Neighbour")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-thirteen-an-employer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: An Employer")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-fourteen-an-instinct",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: An Instinct")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-fifteen-a-refuge-worker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: A Refuge Worker")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-sixteen-a-solicitor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: A Solicitor")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-seventeen-a-case-manager",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: A Case Manager")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-eighteen-a-foetus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: A Foetus")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-nineteen-a-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: A Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-twenty-a-birth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty: A Birth")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-twenty-one-a-moment-of-redemption",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One: A Moment of Redemption")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-twenty-two-freedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two: Freedom")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-twenty-three-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three: Life")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0